import { Table } from "antd";
import { useEmployeeAdvancePaymentList } from "AppQuries/loan/advance-payment";
import TableTop from "Components/UI/TableTop";
import { loggedInUser } from "core/redux/slice/authSlice";
import { format } from "date-fns";
import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle } from "react-feather";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "Router/all_routes";

const AdvancePaymentDetail = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();

  const {
    data: advancePaymentDetails,
    advancePaymentList: isAdvancePaymentListLoading,
    isError,
    error,
    refetch: getAdvancePaymentData,
  } = useEmployeeAdvancePaymentList({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    code: code,
  });

  const columns = [
    {
      title: "Installment Date",
      dataIndex: "installmentDate",
      key: "repaymentDate",
      render: (text) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Installment Amount",
      dataIndex: "installmentAmount",
      key: "repaymentAmount",
    },
    {
      title: "Paid Amount",
      dataIndex: "paidAmount",
      key: "paidAmount",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
    },
    {
      title: "ShowI n Payslip",
      dataIndex: "showInPayslip",
      key: "showInPayslip",
      render: (text) => (text ? "Yes" : "No"),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Employee Advance Payment Details</h4>
            <h6>View and manage advance payments</h6>
          </div>
          {/* <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Add RePayment</Tooltip>}
            >
              <Link
                to={`${all_routes.advance_payment}${all_routes.advance_payment_add}`}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Add Advance Payment
              </Link>
            </OverlayTrigger>
          </div> */}
          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.advance_payment}${all_routes.advance_payment_list}`}
                className="btn btn-secondary"
              >
                {/* <PlusCircle className="me-2" /> */}
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>
        <div className="card border-0">
          <div className="card-body border-0">
            {/* <div className="card-header">
              <h4 className="card-title">Advance Payment Details</h4>
            </div> */}
            <div className="card-body">
              <div className="emp-details d-flex">
                <div className="emp-name-id">
                  <h6>
                    Emp Name :
                    <span>{advancePaymentDetails?.[0]?.employeeName}</span>
                  </h6>
                  <h6>
                    Emp Code : <span>{advancePaymentDetails?.[0]?.uniqueID}</span>
                  </h6>
                  <h6>
                    Designation :
                    <span>{advancePaymentDetails?.[0]?.designationName}</span>
                  </h6>
                  <h6>
                    Department :
                    <span>{advancePaymentDetails?.[0]?.departmentName}</span>
                  </h6>
                </div>
                <div className="emp-location-info">
                  <h6>
                    Advance Date :
                    <span>
                      {format(
                        new Date(advancePaymentDetails?.[0]?.advanceDate),
                        "dd-MM-yyyy"
                      )}
                    </span>
                  </h6>
                  <h6>
                    Advance Amount :
                    <span>{advancePaymentDetails?.[0]?.advanceAmount}</span>
                  </h6>
                  <h6>
                    Paid Amount :
                    <span>{advancePaymentDetails?.[0]?.paidAmount}</span>
                  </h6>
                  <h6>
                    Balance Amount :
                    <span>{advancePaymentDetails?.[0]?.balanceAmount}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-list-card">
                  <div className="table-responsive">
                    <Table
                      loading={isAdvancePaymentListLoading}
                      columns={columns}
                      dataSource={advancePaymentDetails?.[0]?.advancePaymentDetails || []}
                      rowKey="code"
                      pagination={false}
                      bordered
                      // scroll={{ x: 1500 }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdvancePaymentDetail;
